import type { Edge, Node } from '@xyflow/react';

export type NodeKind =
  | 'startEnd'
  | 'process'
  | 'decision'
  | 'inputOutput'
  | 'annotation'
  | 'group';

/** Handles de saída do nó de decisão (compatível com fluxos existentes). */
export type DecisionBranchId = 'top' | 'yes' | 'no' | 'left';

export type FlowNodeData = {
  label: string;
  color?: string;
  /** Rótulos das saídas da decisão (ex.: Sim / Não / Outro). */
  branchLabels?: Partial<Record<DecisionBranchId, string>>;
};

export type AppNode = Node<FlowNodeData>;

export type EdgePathType = 'bezier' | 'smoothstep' | 'step' | 'straight';

export type FlowEdgeData = {
  label?: string;
  pathType?: EdgePathType;
};

export type AppEdge = Edge<FlowEdgeData>;

/** Cor canônica das linhas (modo claro / exportação). */
export const EDGE_DEFAULT_STROKE = '#000000';
/** Cor padrão das linhas no modo noturno (só na tela). */
export const EDGE_DEFAULT_STROKE_DARK = '#ffffff';

export function isDefaultEdgeStroke(stroke: string | undefined): boolean {
  return (
    !stroke ||
    stroke === EDGE_DEFAULT_STROKE ||
    stroke === EDGE_DEFAULT_STROKE_DARK
  );
}

/** Resolve a cor da linha conforme o tema; exportação usa sempre o modo claro. */
export function resolveEdgeStroke(
  stored: string | undefined,
  colorMode: 'light' | 'dark',
): string {
  if (isDefaultEdgeStroke(stored)) {
    return colorMode === 'dark' ? EDGE_DEFAULT_STROKE_DARK : EDGE_DEFAULT_STROKE;
  }
  return stored as string;
}

export const NODE_KINDS: NodeKind[] = [
  'startEnd',
  'process',
  'decision',
  'inputOutput',
  'annotation',
  'group',
];

export const EDGE_PATH_TYPES: EdgePathType[] = [
  'smoothstep',
  'bezier',
  'step',
  'straight',
];
